var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 图片裁切
 */
const TOO_BROAD_RATIO = 9 / 16;
const TOO_HIGH_RATIO = 16 / 9;
export const SHORT_SIDE_SIZE = 640;
export const LONG_SIDE_SIZE = SHORT_SIDE_SIZE / 9 * 16;
export const getImageInstance = (img) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = img;
        image.onload = () => {
            resolve(image);
        };
    });
});
/**
 * 获取图片放大尺寸
 */
export const getImageScaleSize = (base64) => __awaiter(void 0, void 0, void 0, function* () {
    let { width, height } = yield getImageInstance(base64);
    // 缩放到短边为: SHORT_SIDE_SIZE
    const scale = Math.min(width, height) / SHORT_SIDE_SIZE;
    return {
        width: width / scale,
        height: height / scale,
    };
});
/**
 * 裁切
 */
export const autoCrop = (imageBase64, ctx, canvas, croppedCanvas) => __awaiter(void 0, void 0, void 0, function* () {
    const originImageInfo = yield getImageScaleSize(imageBase64);
    // 注意，这边没有真正对图片进行缩放，需要先会绘制到 canvas 上，然后再获取信息进行裁剪
    // 绘制缩放后的图片
    const $originImage = yield getImageInstance(imageBase64);
    ctx.drawImage($originImage, 0, 0, originImageInfo.width, originImageInfo.height);
    const croppedImage = canvas.toDataURL('image/jpeg', 1);
    const originRatio = originImageInfo.height / originImageInfo.width;
    // 太宽 -> 宽度裁剪到 高度/9*16
    if (originRatio < TOO_BROAD_RATIO) {
        const width = originImageInfo.height / 9 * 16;
        const { height } = originImageInfo;
        const left = (originImageInfo.width - width) / 2;
        const top = 0;
        return yield getImageData(canvas, croppedImage, ctx, croppedCanvas, originImageInfo.width, originImageInfo.height, left, top, width, height);
    }
    if (originRatio > TOO_HIGH_RATIO) {
        // 太高   -> 高度裁剪到  宽度/9*16
        const { width } = originImageInfo;
        const height = originImageInfo.width / 9 * 16;
        const left = 0;
        const top = (originImageInfo.height - height) / 2;
        return yield getImageData(canvas, croppedImage, ctx, croppedCanvas, originImageInfo.width, originImageInfo.height, left, top, width, height);
    }
    // 维持原有比例, 进行缩放
    const { width, height } = originImageInfo;
    return yield getImageData(canvas, croppedImage, ctx, croppedCanvas, width, height, 0, 0, width, height);
});
/**
 * 先把图片从(0,0)画出来, 然后根据目标坐标 导出base64
 * @param imgFilePath
 * @param width
 * @param height
 * @param targetLeft
 * @param targetTop
 * @param targetWidth
 * @param targetHeight
 */
const getImageData = (canvas, imgFilePath, ctx, croppedCanvas, width, height, targetLeft, targetTop, targetWidth, targetHeight) => __awaiter(void 0, void 0, void 0, function* () {
    // 绘制，然后根据目标
    const imageElement = yield getImageInstance(imgFilePath);
    // targetLeft: 裁切 x，targetTop： 裁切 y，targetWidth：裁切宽度，targetHeight: 裁切高度
    // 需要在一个新的canvas 上绘制
    ctx.drawImage(imageElement, targetLeft, targetTop, targetWidth, targetHeight, 0, 0, targetWidth, targetHeight);
    const imageData = ctx.getImageData(0, 0, targetWidth, targetHeight);
    croppedCanvas.width = targetWidth;
    croppedCanvas.height = targetHeight;
    const croppedCtx = croppedCanvas.getContext('2d');
    croppedCtx.putImageData(imageData, 0, 0);
    return croppedCanvas.toDataURL('image/jpeg', 1);
});
